import { create } from "zustand";
import { ActionsKey } from "../../../../common/models/Actions";
import { initialUserPageState, UserItemData } from "../core/_model.user";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../../common/models/StoreDefaultModel";

export type ActionedUser = {
  data: UserItemData | null;
  action: ActionsKey;
};

type UserDataType = {
  userList: any;
  detail: UserItemData | null;
  actioned: ActionedUser | null;
  totalItems?: number;
  setDetail: (detail: UserItemData | null) => void;
  setUserList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedUser | null) => void;
};

export const useUserStore = create<UserDataType>((set) => ({
  userList: [],
  detail: null,
  actioned: null,

  setDetail: (detail) => set((state) => ({ detail })),
  setUserList: (saleData) =>
    set((state) => ({
      userList: saleData?.member,
      totalItems: saleData?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));

export const useUserListState = create<DefaultListStateType>((set) => ({
  pageState: initialUserPageState,
  setPageState: (pageState) => set((state) => ({ pageState })),
  resetPageState: () =>
    set(() => ({
      pageState: initialUserPageState,
    })),
}));
